{
  "enums": {
    "claimStatus": {
      "draft": "草稿",
      "submitted": "已提交",
      "accepted": "已受理",
      "denied": "已拒付",
      "paid": "已付款"
    },
    "chargeStatus": {
      "pending": "待處理",
      "unbilled": "未開帳",
      "posted": "已入帳",
      "billed": "已開帳",
      "adjusted": "已調整",
      "voided": "已作廢"
    },
    "statementDelivery": {
      "print": "列印",
      "email": "電郵",
      "both": "列印及電郵",
      "mail": "郵寄"
    },
    "statementStatus": {
      "generated": "已產生",
      "sent": "已寄出",
      "viewed": "已檢視"
    },
    "denialStatus": {
      "new": "新建",
      "inReview": "審核中",
      "appealing": "申訴中",
      "resolved": "已解決",
      "writtenOff": "已核銷"
    },
    "denialPriority": {
      "low": "低",
      "medium": "中",
      "high": "高"
    },
    "claimType": {
      "professional": "專業服務",
      "institutional": "機構",
      "dental": "牙科",
      "pharmacy": "藥房"
    },
    "paymentMethod": {
      "cash": "現金",
      "check": "支票",
      "creditCard": "信用卡",
      "debitCard": "扣帳卡",
      "bankTransfer": "銀行轉帳",
      "digitalWallet": "電子錢包",
      "insurance": "保險"
    },
    "paymentSource": {
      "patient": "病人",
      "insurance": "保險",
      "thirdParty": "第三方"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "病人 ID 為必填欄位",
      "encounterIdRequired": "就診 ID 為必填欄位",
      "payerIdRequired": "付款方 ID 為必填欄位",
      "chargeCodeRequired": "收費代碼為必填欄位",
      "unitPriceRequired": "單價為必填欄位",
      "amountRequired": "金額為必填欄位",
      "amountPositive": "金額必須大於零",
      "chargeSelectionRequired": "請最少選擇一項收費"
    }
  },
  "pages": {
    "statements": {
      "title": "帳單結算單",
      "labels": {
        "dashboard": "儀表板",
        "patient": "病人",
        "from": "起始",
        "to": "截止",
        "batchGenerate": "批次產生",
        "previewStatement": "預覽結算單",
        "generatePrint": "產生並列印",
        "generateEmail": "產生並傳送電郵",
        "printEmail": "列印及電郵",
        "print": "列印",
        "email": "電郵"
      },
      "placeholders": {
        "searchPatient": "按姓名或病歷號搜尋..."
      },
      "aria": {
        "periodFrom": "結算單期間起始",
        "periodTo": "結算單期間截止"
      },
      "table": {
        "header": {
          "statementHistory": "結算單記錄",
          "patient": "病人",
          "mrn": "病歷號",
          "date": "日期",
          "amount": "金額",
          "delivery": "傳送方式",
          "status": "狀態"
        },
        "preview": {
          "modal": "結算單預覽",
          "patientStatement": "病人結算單",
          "patient": "病人:",
          "mrn": "病歷號:",
          "statementDate": "結算單日期:",
          "period": "期間:",
          "lineItemHeader": {
            "date": "日期",
            "description": "說明",
            "charges": "費用",
            "payments": "付款",
            "balance": "餘額"
          },
          "openingBalance": "期初餘額",
          "totals": "合計",
          "amountDue": "應付金額"
        }
      },
      "states": {
        "generating": "產生中...",
        "loading": "正在產生預覽...",
        "noPatients": "找不到病人",
        "noStatementData": "無可用結算單資料",
        "loadingHistory": "正在載入記錄...",
        "noStatementsGenerated": "尚未產生結算單",
        "selectedPatientId": "已選病人 ID:{{id}}"
      },
      "toast": {
        "generated": "結算單已產生",
        "generatedError": "產生結算單失敗",
        "batchStarted": "批次產生已開始:已排入 {{count}} 份結算單",
        "batchError": "啟動批次產生失敗"
      }
    },
    "claims": {
      "title": "理賠管理",
      "labels": {
        "dashboard": "儀表板",
        "createClaim": "建立理賠",
        "filters": "篩選",
        "submit": "提交",
        "appeal": "申訴",
        "denialReason": "拒賠原因",
        "expandHint": "展開理賠以在專用理賠頁面查看明細項目。",
        "cancel": "取消"
      },
      "filter": {
        "allStatuses": "所有狀態"
      },
      "placeholders": {
        "filterPayer": "按付款方篩選..."
      },
      "aria": {
        "claimDateFrom": "理賠日期由",
        "claimDateTo": "理賠日期至"
      },
      "table": {
        "header": {
          "claimNumber": "理賠編號",
          "patient": "病人",
          "payer": "付款方",
          "total": "總計",
          "status": "狀態",
          "submitted": "已提交",
          "actions": "操作"
        }
      },
      "modal": {
        "createClaim": "從費用建立理賠",
        "patientId": "病人 ID *",
        "payerId": "付款方 ID *",
        "selectCharges": "選擇費用（已選 {{selected}} 項）",
        "noBilledCharges": "此病人沒有未開賬單的費用"
      },
      "states": {
        "loading": "正在載入理賠...",
        "noClaims": "找不到理賠",
        "creating": "正在建立..."
      },
      "toast": {
        "created": "理賠已建立",
        "createdError": "建立理賠失敗",
        "submitted": "理賠已提交",
        "submittedError": "提交理賠失敗",
        "resubmitted": "理賠已重新提交以申訴",
        "resubmittedError": "重新提交理賠失敗",
        "patientPayerRequired": "病人和付款方為必填項",
        "chargeRequired": "至少選擇一項費用"
      }
    },
    "charges": {
      "title": "費用管理",
      "labels": {
        "dashboard": "儀表板",
        "newCharge": "新增費用",
        "totalChargesPeriod": "費用總計（期間）",
        "filters": "篩選",
        "cancel": "取消"
      },
      "filter": {
        "allStatuses": "所有狀態"
      },
      "placeholders": {
        "filterPatient": "按病人篩選..."
      },
      "aria": {
        "serviceDateFrom": "服務日期由",
        "serviceDateTo": "服務日期至"
      },
      "table": {
        "header": {
          "date": "日期",
          "patient": "病人",
          "encounter": "就診",
          "code": "代碼",
          "description": "說明",
          "qty": "數量",
          "unitPrice": "單價",
          "total": "總計",
          "status": "狀態",
          "actions": "操作"
        }
      },
      "actions": {
        "void": "作廢"
      },
      "modal": {
        "voidCharge": "作廢費用",
        "voidChargeConfirm": "作廢費用 {{code}} - {{description}}（{{amount}}）？",
        "reason": "原因 *",
        "reasonPlaceholder": "請輸入作廢原因..."
      },
      "states": {
        "loading": "正在載入費用...",
        "noCharges": "此期間內未找到費用",
        "voiding": "正在作廢..."
      },
      "toast": {
        "voided": "費用已作廢",
        "voidedError": "作廢費用失敗",
        "reasonRequired": "原因為必填項"
      }
    },
    "payments": {
      "title": "付款登記",
      "labels": {
        "dashboard": "儀表板",
        "uploadEraEob": "上載 ERA/EOB",
        "postPayment": "登記付款",
        "totalPaymentsPeriod": "付款總額（期間）",
        "filters": "篩選",
        "cancel": "取消"
      },
      "placeholders": {
        "filterPatient": "按病人篩選..."
      },
      "aria": {
        "paymentDateFrom": "付款日期（由）",
        "paymentDateTo": "付款日期（至）"
      },
      "table": {
        "header": {
          "date": "日期",
          "patient": "病人",
          "claimNumber": "理賠編號",
          "amount": "金額",
          "method": "方式",
          "reference": "參考",
          "postedBy": "登記人"
        }
      },
      "modal": {
        "postPayment": "登記付款",
        "patientId": "病人 ID *",
        "claimId": "理賠 ID（可選）",
        "claimIdHint": "未套用付款請留空",
        "amount": "金額 *",
        "method": "方式 *",
        "referenceNumber": "參考編號",
        "referenceHint": "支票號、交易 ID 等",
        "notes": "備註"
      },
      "states": {
        "loading": "正在載入付款...",
        "noPayments": "此期間內找不到付款",
        "posting": "正在登記..."
      },
      "toast": {
        "posted": "付款登記成功",
        "postedError": "付款登記失敗",
        "patientAmountRequired": "病人和金額為必填項",
        "validAmount": "請輸入有效金額",
        "eraEobSoon": "ERA/EOB 上載即將推出"
      }
    },
    "chargeForm": {
      "title": "建立費用",
      "labels": {
        "patientId": "病人 ID *",
        "encounterId": "就診 ID *",
        "chargeCode": "費用代碼 *",
        "description": "說明",
        "cptCode": "CPT 代碼",
        "quantity": "數量 *",
        "unitPrice": "單價 *"
      },
      "placeholders": {
        "chargeCode": "搜尋費用主檔...",
        "cptCode": "搜尋 CPT 程序代碼..."
      },
      "buttons": {
        "cancel": "取消",
        "create": "建立費用"
      },
      "toast": {
        "created": "費用已建立",
        "createdError": "建立費用失敗"
      }
    },
    "claimForm": {
      "title": "建立理賠",
      "labels": {
        "patientId": "病人 ID *",
        "encounterId": "就診 ID *",
        "payerId": "付款方 ID *",
        "claimType": "理賠類型 *",
        "diagnosisCodes": "診斷代碼",
        "selectCharges": "選擇費用（已選 {{selected}} 項）",
        "notes": "備註"
      },
      "placeholders": {
        "diagnosisCodes": "以逗號分隔的 ICD-10 代碼（如 J06.9, R05）"
      },
      "buttons": {
        "cancel": "取消",
        "create": "建立理賠"
      },
      "toast": {
        "created": "理賠已建立",
        "createdError": "建立理賠失敗"
      }
    },
    "paymentForm": {
      "title": "登記付款",
      "labels": {
        "patientId": "病人 ID *",
        "claimId": "理賠 ID",
        "amount": "金額 *",
        "method": "付款方式 *",
        "source": "來源",
        "referenceNumber": "參考編號",
        "notes": "備註"
      },
      "placeholders": {
        "claimId": "可選 — 連結至理賠",
        "reference": "交易或支票參考"
      },
      "buttons": {
        "cancel": "取消",
        "post": "登記付款"
      },
      "toast": {
        "recorded": "付款已記錄",
        "recordedError": "記錄付款失敗"
      }
    },
    "denials": {
      "title": "拒付管理",
      "subtitle": "追蹤及管理理賠拒付",
      "placeholders": {
        "search": "搜尋理賠..."
      },
      "filter": {
        "all": "全部"
      },
      "checkbox": {
        "assignedToMe": "指派給我"
      },
      "table": {
        "header": {
          "claimNumber": "理賠編號",
          "patient": "病人",
          "denialCode": "拒付代碼",
          "denialReason": "拒付原因",
          "amount": "金額",
          "daysRemaining": "剩餘日數",
          "status": "狀態",
          "assignedTo": "負責人",
          "actions": "操作"
        }
      },
      "actions": {
        "review": "審核",
        "appeal": "申訴",
        "writeOff": "撇帳",
        "cancel": "取消"
      },
      "modal": {
        "appealReason": "申訴原因",
        "appealPlaceholder": "請描述申訴原因...",
        "submitAppeal": "提交申訴",
        "writeOffTitle": "撇帳拒付",
        "writeOffConfirm": "確定要將理賠 {{claimNumber}} 以 {{amount}} 撇帳嗎？此操作無法撤銷。",
        "writeOffButton": "撇帳"
      },
      "states": {
        "loading": "正在載入拒付...",
        "noDenials": "找不到拒付",
        "submitting": "正在提交..."
      },
      "toast": {
        "updateError": "更新拒付狀態失敗",
        "movedToReview": "理賠 {{claimNumber}} 已移至審核",
        "appealSubmitted": "申訴已提交",
        "writtenOff": "理賠 {{claimNumber}} 已撇帳"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
